import { connect } from 'react-redux'
import StatusNotConnected from './status-not-connected'
import {
  connectToWonde,
  requestGroupCallAccess,
  searchWondeSchoolsToRequest
} from '../../../../../../../stores/school-data/school-data.actions'
import { getSchoolData } from '../../../../../../../stores/school-data/school-data.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = state => {
  const school = getSchoolData(state)
  return {
    id: school.id,
    statusColor: school.wonde.color
  }
}

const mapDispatchToProps = dispatch => ({
  onSearchChange: term =>
    dispatch(searchWondeSchoolsToRequest(term)).catch(errorHandler),
  onConnect: (schoolId, wondeId) => {
    dispatch(connectToWonde(schoolId, wondeId)).catch(errorHandler)
  },
  onRequest: schoolId => {
    dispatch(requestGroupCallAccess(schoolId))
      .then(() =>
        toast.success(
          "You successfully requested a connection with GroupCall. We'll get back to you shortly."
        )
      )
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusNotConnected)
